/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".trow[_ngcontent-%COMP%]{width:17%}.icon-image-preview[_ngcontent-%COMP%]{vertical-align:middle}h4[_ngcontent-%COMP%]{font-weight:700}"];
export { styles as styles };

